<template>
  <public-collections-gallery
    v-if="collectionInfo"
    :collectionInfo="collectionInfo"
  ></public-collections-gallery>
  <div v-else>
    <md-card :id="id" class="md-card-unspaced public-card rfider-shadow">
      <div
        v-if="!embeds && (item.image || item.secondaryImage)"
        class="public-support-image"
        :style="{
          'background-image': item.image
            ? `url(${mixinGetFilePath(
                item.image,
                imageExtension === 'gif' ? 'O' : 'XL',
              )})`
            : 'none',
          cursor: item.imageLink ? 'pointer' : '',
        }"
        @click.prevent="openLink(item)"
      >
        <div
          v-if="item.secondaryImage"
          :style="{
            'background-image': item.secondaryImage
              ? `url(${mixinGetFilePath(
                  item.secondaryImage,
                  secondaryImageExtension === 'gif' ? 'O' : 'XL',
                )})`
              : 'none',
          }"
          class="public-support-secondary-image"
        ></div>
      </div>
      <md-card-content v-if="!embeds && hasContent" class="public-card-content">
        <div class="public-card-name ql-editor" v-if="item.title">
          {{ item.title }}
        </div>
        <div v-if="item.phone">
          <a :href="`tel:${item.phone}`" target="_blank">
            <img :src="'/img/avatars/avatar-phone.png'" class="avatar-image" />
            {{ item.phone }}
          </a>
        </div>
        <div v-if="item.email">
          <a :href="`mailto:${item.email}`" target="_blank">
            <img :src="'/img/avatars/avatar-email.png'" class="avatar-image" />
            {{ item.email }}
          </a>
        </div>
        <div v-if="item.message">
          <div
            v-if="item.expanded"
            class="ql-editor"
            v-html="item.message"
          ></div>
          <div v-else class="ql-editor">
            <public-expand
              :item="item.message"
              refKey="support"
            ></public-expand>
          </div>
        </div>
        <public-google-maps
          :kmlUrl="mixinGetFilePath(item.kmlLink, 'O')"
          :kmlMap="item.kmlMap"
          :kmlHistoryImagery="item.kmlHistoryImagery"
          v-if="item.kmlLink"
        />
      </md-card-content>
      <md-card-content v-if="embeds" class="public-card-content">
        <div
          v-for="(embed, index) in embeds"
          :key="index"
          class="public-support-embed"
        >
          <iframe
            :src="embed"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import PublicExpand from '@/components/public/publicExpand.vue';
import PublicCollectionsGallery from '@/components/public/publicCollectionsGallery.vue';
import PublicGoogleMaps from './publicGoogleMaps.vue';

export default {
  inject: ['registerCodeInjection'],
  components: {
    PublicExpand,
    PublicCollectionsGallery,
    PublicGoogleMaps,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.item) {
      if (
        this.registerCodeInjection &&
        this.item.codeInjection &&
        !this.embeds
      ) {
        this.registerCodeInjection(this.id, this.item.codeInjection);
      }
    }
  },
  computed: {
    id() {
      return this.item ? 'component-support-' + this.item.id : null;
    },
    hasContent() {
      return (
        this.item &&
        (this.item.title ||
          this.item.phone ||
          this.item.email ||
          this.item.message)
      );
    },
    hasKML() {
      return this.item && this.item.kmlLink;
    },
    embeds() {
      let arr = [];
      if (this.item && this.item.embeddedLink) {
        arr = this.item.embeddedLink
          .replace(/\r\n/g, '\r')
          .replace(/\n/g, '\r')
          .split(/\r/);
      }
      return arr.length ? arr : null;
    },
    imageExtension() {
      try {
        return this.item.image.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
    secondaryImageExtension() {
      try {
        return this.item.secondaryImage.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
    collectionInfo() {
      let collectionInfo = null;
      if (
        Array.isArray(this.item.collectionsInfo) &&
        this.item.collectionsInfo.length
      ) {
        collectionInfo = {
          ...this.item.collectionsInfo[0],
          ...this.item,
        };
      }
      return collectionInfo;
    },
  },
  methods: {
    openLink(item) {
      if (item && item.imageLink) {
        window.open(item.imageLink, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.public-card {
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}
.public-card-content {
  padding: 15px 20px;
}
.public-card-name {
  font-weight: 600;
  font-size: 20px;
  margin: 20px 0;
  white-space: initial;
  text-align: center;
}
.public-support-image {
  position: relative;
  background-size: cover !important;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px 10px 0px 0px;

  &:after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }

  .public-support-secondary-image {
    position: absolute;
    background-size: contain !important;
    background-position: center;
    background-repeat: no-repeat;
    width: 40%;
    top: 50%;
    left: 50%;
    border-radius: 10px;
    z-index: 1;
    transform: translate(-50%, -50%);

    &:after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }
  }
}
.avatar-image {
  width: 24px;
  height: 24px;
}
.public-support-message {
  padding: 0 20px;
  width: 100%;
}
.public-support-embed {
  position: relative;
  padding-top: 56.25%;

  + .public-support-embed {
    margin-top: 10px;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
